// --------------------------------------------------------------------------
// config.js
// --------------------------------------------------------------------------
// Used for anything that needs to be declared before your modules.
// --------------------------------------------------------------------------

var EC = window.EC || {};